import { inject } from "@angular/core";
import { RedirectCommand, ResolveFn, Router } from "@angular/router";
import { config } from "@config";

export const securityTransferRedirectResolver: ResolveFn<boolean | RedirectCommand> = (route) => {
	const router = inject(Router);
	const transferId = route.paramMap.get("pid");

	if (!transferId) {
		return new RedirectCommand(router.parseUrl("/my-account/history"));
	}

	const baseUrl = config.V4AppBaseUrl.endsWith("/") ? config.V4AppBaseUrl : `${config.V4AppBaseUrl}/`;
	const redirectUrl = `${baseUrl}?o=modal-security-transfer-download&transferId=${transferId}`;
	window.location.assign(redirectUrl);
	return true;
};
